import React, { useState } from "react";
import Chart from "react-apexcharts";

const OverviewChart = () => {
  // Defualt chart states
  const [options, setOptions] = useState({
    chart: {
      id: "performance-donut-chart",
    },
    labels: ["Liverpool Street Handheld Team #1", "Liverpool Street Charity Zone #2",  "Liverpool Street Handheld Team #2", "London Central Cafe"],
    dataLabels: {
      enabled: false,
    },
    colors: ["#35E0CE", "#5F8DF5", "#EB43CB", "#f0a64f"],
    states: {
      hover: {
        filter: {
          type: "darken",
          value: 0.65,
        },
      },
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            total: {
              show: true,
              formatter: (opts) => {
                return `£${(opts.globals.series.reduce((a, b) => a + b, 0)).toLocaleString()}`;
              },
            },
            show: true,
            name: {
              show: false,
              fontSize: "100px",
              offsetY: 20,
              color: "#373d3f",
            },
            value: {
              color: "#35E0CE",
              offsetY: 5,
              fontSize: "1.5rem",
              // Show percentage in total Value
              formatter: (value, opts) => {
                // reduce adds up all series data. The zero is default if series not found.
                let sum = opts.globals.series.reduce((a, b) => a + b, 0);
                const percent = (value / sum) * 100;
                return percent.toFixed(0) + "%";
              },
            },
          },
        },
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
    },
  });
  const [series, setSeries] = useState([1425, 1220, 855, 685]);

  // Toggle Chart Settings
  const [active, setActive] = useState("year");
  let chartItem = "home__charts__list-items__item";
  const handleClick = (item) => {
    setActive(item);
    switch (item) {
      case "today":
        setOptions({...options, labels: ["Liverpool Street Handheld Team #1", "Liverpool Street Charity Zone #2",  "Liverpool Street Handheld Team #2"] })
        setSeries([855, 565 , 115])
        break;
      case "week":
        setOptions({...options, labels: ["Liverpool Street Handheld Team #1", "Liverpool Street Charity Zone #2",  "Liverpool Street Handheld Team #2", "London Central Cafe"] })
        setSeries([860, 685, 40, 80])
        break;
      case "month":
        setOptions({...options, labels: ["Liverpool Street Handheld Team #1", "Liverpool Street Charity Zone #2",  "Liverpool Street Handheld Team #2", "London Central Cafe"] })
        setSeries([985, 825, 770, 370])
        break;
      case "year":
        setOptions({...options, labels: ["Liverpool Street Handheld Team #1", "Liverpool Street Charity Zone #2",  "Liverpool Street Handheld Team #2", "London Central Cafe"] })
        setSeries([1425, 1220, 855, 685])
        break;
      default:
      // do nothing right now.
    }
  };

  return (
    <div className="home__charts__box">
      <div className="home__charts__options">
        <p className="home__charts__title">Performance</p>
        <ul className="home__charts__list-items">
          <li
            onClick={(e) => {
              handleClick("today");
            }}
            className={
              active === "today"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Today
          </li>
          <li
            onClick={(e) => {
              handleClick("week");
            }}
            className={
              active === "week"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Week
          </li>
          <li
            onClick={(e) => {
              handleClick("month");
            }}
            className={
              active === "month"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Month
          </li>
          <li
            onClick={(e) => {
              handleClick("year");
            }}
            className={
              active === "year"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Year
          </li>
        </ul>
      </div>
      <div className="home__charts__row">
        <Chart
          className="home__charts__chart"
          options={options}
          series={series}
          type="donut"
          width="100%"
          height="325"
        />
        <div>
          <table className="home__charts__table">
            <thead>
              <tr className="home__charts__table__row">
                <th className="home__charts__table__header home__charts__table__system">
                  System
                </th>
                <th className="home__charts__table__header home__charts__table__percentage">
                  Percentage
                </th>
                <th className="home__charts__table__header home__charts__table__total">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {series.map((data, index) => {
                console.log(options);
                return (
                  <tr key={index} className="home__charts__table__row">
                    <td className="home__charts__table__system">
                      {options.labels[index]}
                    </td>
                    <td className="home__charts__table__percentage">{`${(
                      (data / series.reduce((a, b) => a + b, 0)) *
                      100
                    ).toFixed(0)}%`}</td>
                    <td className="home__charts__table__total">£{data.toLocaleString()}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OverviewChart;
